import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * @hook useSOSStickyBar
 * @description Hook para gestionar la visibilidad de la barra sticky SOS
 */

interface UseSOSStickyBarOptions {
  /** Rutas donde NO mostrar la barra sticky */
  excludedPaths?: string[];
  /** Patrones de rutas a excluir (regex) */
  excludedPatterns?: RegExp[];
}

export const useSOSStickyBar = (options: UseSOSStickyBarOptions = {}) => {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(true);

  const defaultExcludedPaths = [
    '/checkout',
    '/payment',
    '/admin',
    '/sos',
    '/auth/login',
    '/auth/register',
    '/auth/reset-password',
    '/activate',
    '/onboarding',
    '/claim'
  ];

  const defaultExcludedPatterns = [
    /^\/admin\/.*/,
    /^\/checkout\/.*/,
    /^\/payment\/.*/,
    /^\/activate\/.*/,
    /^\/onboarding\/.*/,
    /^\/claim\/.*/,
    /.*\/modal\/.*/
  ];

  const excludedPaths = [...defaultExcludedPaths, ...(options.excludedPaths || [])];
  const excludedPatterns = [...defaultExcludedPatterns, ...(options.excludedPatterns || [])];

  useEffect(() => {
    const currentPath = location.pathname;

    // Verificar rutas exactas excluidas
    const isExcludedPath = excludedPaths.includes(currentPath);

    // Verificar patrones excluidos
    const isExcludedPattern = excludedPatterns.some(pattern => pattern.test(currentPath));

    // Verificar si hay modales abiertos (por clase CSS)
    const hasOpenModal = document.body.classList.contains('modal-open') || 
                        document.querySelector('[role="dialog"]') !== null;

    // Ocultar si está en ruta excluida, patrón excluido, o hay modal abierto
    setIsVisible(!isExcludedPath && !isExcludedPattern && !hasOpenModal);
  }, [location.pathname, excludedPaths, excludedPatterns]);

  // Función para ocultar manualmente (útil para modales críticos)
  const hideStickyBar = () => setIsVisible(false);

  // Función para mostrar manualmente
  const showStickyBar = () => setIsVisible(true);

  return {
    isVisible,
    hideStickyBar,
    showStickyBar
  };
};
